module.exports = __webpack_public_path__ + "media/images/logos/facebook-798ff419268bc0baf33577488789967c.svg";